import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getInstallationDateChangeListing } from 'services/redux/installation/siteListing/action';
import InstallationRequestListing from './installationRequestListing';

const mapStateToProps = (state) => ({
    installationDateChangeListing: state.siteListingReducer.installationDateChangeListing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getInstallationDateChangeListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InstallationRequestListing);
